import { Component, Input, OnDestroy,HostListener, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Product } from '../shared/model/ui/product';
import { CmElement, CmTooltip, ContentType } from '../shared/model/cm/managed-content.model';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { CmFormElement } from '../shared/model/cm-form-element';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { RadioButton } from '../shared/model/session/radio-button';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { LifeScheduleDollarComponent } from '../life-schedule-dollar/life-schedule-dollar.component';
import { LifeScheduleSalaryComponent } from '../life-schedule-salary/life-schedule-salary.component';

@Component({
selector: 'app-life-schedule-radio',
  standalone: true,
  imports: [ReactiveFormsModule, LifeScheduleDollarComponent, LifeScheduleSalaryComponent],
  templateUrl: './life-schedule-radio.component.html',
  styleUrls: ['./life-schedule-radio.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LifeScheduleRadioComponent implements OnInit, OnDestroy, AfterViewInit  {
  @Input() parentForm: FormGroup;
  @Input() product: Product;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public innerWidth: number = window.innerWidth;
  public lifeStructureTooltipPosition: string = 'top';

  public lifeStructureContent: CmElement;
  public lifeStructureElement: CmFormElement;
  public lifeStructureToolTipDescription: string;
  public lifeStructureToolTip: CmTooltip;
  public lifeStructureToolTipTitle: string;
  public screenOrientation: string ="horizontal";

  public bothSchedule: RadioButton[] = [
    { abbreviation: "dollar", label: "Dollar"},
    { abbreviation: "salary", label: "Multiple of Salary"},
  ];

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService
  ) { }

  ngOnInit(): void {

    this.lifeStructureContent = this.cmService.getContentById(ContentType.ELEMENT, 'life-insurance-structure');
    this.lifeStructureElement = this.cmService.getContentById(ContentType.ELEMENT, 'life-insurance-structure');

    this.lifeStructureElement.errorsObject = {
      required: this.lifeStructureContent.error
    }

    this.lifeStructureToolTip = this.cmService.getContentById(ContentType.TOOLTIP, this.lifeStructureElement.tooltip);
    this.lifeStructureToolTipTitle = this.lifeStructureToolTip.title;
    this.lifeStructureToolTipDescription = this.lifeStructureToolTip.plainText;

    if(this.parentForm){
      this.parentForm.addControl(this.product.key + '_schedule', this.fb.control('', [Validators.required]));
      this.parentForm.get(this.product.key + '_schedule').setErrors({required: true});
      this.parentForm.updateValueAndValidity();
    }
      
    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.innerWidth = window.innerWidth;
      this.changeTooltipPosition();
    });
    
  }//end ngOnInit

  ngAfterViewInit(){
    this.innerWidth = window.innerWidth;

    if(this.innerWidth<=768){
      this.screenOrientation="vertical";
    }else{
      this.screenOrientation="horizontal";
    }

    this.changeTooltipPosition();
  }

  ngOnDestroy(): void {
    if(this.parentForm){
      this.parentForm.removeControl(this.product.key + '_schedule');
    }
  }

  changeTooltipPosition(){
    if(this.innerWidth < 921){
      this.lifeStructureTooltipPosition = 'left';
    } else {
      this.lifeStructureTooltipPosition = 'top';
    }
  }

  logLifeRadioChangeEvent(key: string, answer: string){
    this.parentForm.get(key + "_schedule").setValue(answer);
    this.parentForm.get(key + "_schedule").markAsTouched();
  }
}
